import { colors, measure, radius } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

export const buttonPrimitiveTokens = stylex.defineVars({
	borderRadius: radius.round,
	paddingInlineEnd: measure.spacingGapLarger,
	paddingInlineStart: measure.spacingGapLarger,
	gap: measure.spacingGapNarrow,
	iconEnd_paddingInlineEnd: measure.spacingGapDefault,
	iconStart_paddingInlineStart: measure.spacingGapDefault,
});

export const buttonPrimitiveStyles = stylex.create({
	base: {
		alignItems: "center",
		borderColor: "transparent",
		borderRadius: buttonPrimitiveTokens.borderRadius,
		borderStyle: "solid",
		borderWidth: 0,
		cursor: {
			":disabled": "default",
			default: "pointer",
		},
		display: "inline-flex",
		flexShrink: 0,
		flexWrap: "nowrap",
		gap: buttonPrimitiveTokens.gap,
		justifyContent: "center",
		maxInlineSize: "100%",
		minBlockSize: measure.sizeControlsButton,
		outline: {
			":focus-visible": `2px solid ${String(colors.accentBgStrong)}`,
			default: "none",
		},
		outlineOffset: {
			":focus-visible": "2px",
			default: null,
		},
		overflow: "hidden",
		paddingBlock: 0,
		paddingInlineEnd: buttonPrimitiveTokens.paddingInlineEnd,
		paddingInlineStart: buttonPrimitiveTokens.paddingInlineStart,
		position: "relative",
		textDecoration: "none",
		transitionDuration: "200ms",
		transitionProperty: "background-color, color, box-shadow, opacity, border-color",
		transitionTimingFunction: "ease-in-out",
	},
	block: {
		inlineSize: "100%",
	},
	contentHidden: {
		visibility: "hidden",
	},
	iconEnd: {
		paddingInlineEnd: buttonPrimitiveTokens.iconEnd_paddingInlineEnd,
	},
	iconOnly: {
		inlineSize: measure.sizeControlsButton,
		paddingInlineEnd: 0,
		paddingInlineStart: 0,
	},
	iconStart: {
		paddingInlineStart: buttonPrimitiveTokens.iconStart_paddingInlineStart,
	},
	loader: {
		position: "absolute",
	},
	loading: {
		pointerEvents: "none",
	},
});
